import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import { SAlert } from '@avalara/skylab-sdk/react';
import { isFreeTrialExtensionPending } from '@avalara/bat-apps-shared/helpers/obligations';
import Banner from '../banner';
import { PageWrapper } from '../styled/skylab/page';
import TierTile from '../shared/product/tier-tile';
import ExternalLink from '../external-link';
import Cart from './cart';
import { BaseLinkContainer, PickerContainer, TierIntroContainer, TierSelectionPageWrapper, } from '../styled/components/buy-flow';
import { selectState } from '../../selectors';
import analytics from '../../lib/analytics';
import conf from '../../conf';
import { getConnectorSalesTax } from '../../lib/side-effects/avatax';
import { setSelectedTier } from '../../store/buy-flow';
const getTiers = (connector, hideConnectorTiers) => {
    if (!connector.metadata)
        return [];
    const { paidOffer1, paidOffer2, paidOffer3, paidOffer4 } = connector.metadata;
    if (connector.id === 'a0n3300000FSK2zAAH') {
        return [paidOffer2, paidOffer3, paidOffer4];
    }
    if (hideConnectorTiers) {
        return [paidOffer3, paidOffer4];
    }
    return [paidOffer1, paidOffer2, paidOffer4];
};
const TierSelector = () => {
    const dispatch = useDispatch();
    const { account: { accountId, connector }, avataxSignup: { selectedConnector }, buyFlow: { selectedTier, trialExtension }, features, } = useSelector(selectState);
    const connectorToUse = selectedConnector || connector;
    const tiers = getTiers(connectorToUse, features.HIDELOWERCONNECTORTIER);
    const trialWasExtended = isFreeTrialExtensionPending(accountId || 0);
    const hasNonApiConnector = connectorToUse.id !== 'a0n4000000ChMxlAAF';
    useEffect(() => {
        analytics.page('PURCHASE_START', { connector: selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.name.toUpperCase() });
        dispatch(getConnectorSalesTax());
    }, []);
    const onSelectTier = (tier) => dispatch(setSelectedTier(tier));
    return (React.createElement(React.Fragment, null,
        React.createElement(Banner, { backgroundImage: `${conf.ASSET_PATH}/assets/images/banner-background.png`, image: `${conf.ASSET_PATH}/assets/images/company_w.svg`, primaryText: 'Purchase your subscription' }),
        React.createElement(PageWrapper, null,
            React.createElement(TierSelectionPageWrapper, { offsetRight: 50 },
                React.createElement("div", null,
                    React.createElement(TierIntroContainer, null,
                        React.createElement("h2", { className: 'pad-bottom-md', "data-ref": 'buy.tier-selector.header' }, trialExtension
                            ? 'Your free trial has ended — buy a subscription to keep using AvaTax'
                            : 'Purchase your subscription'),
                        trialWasExtended
                            ? React.createElement(SAlert, { "data-ref": 'buy.tier-selector.trial-extended.alert', status: 'warning' },
                                React.createElement("div", null, "Your trial extension is being provisioned, hang tight!"))
                            : null,
                        React.createElement("div", null,
                            React.createElement("img", { className: 'pad-top-md', "data-ref": 'buy.tier-selector.avatax.image', src: `${conf.ASSET_PATH}/assets/images/AvalaraAvaTax.svg`, alt: 'Avalara AvaTax logo' }),
                            React.createElement("p", null, "AvaTax processes billions of tax transactions per year, across 12,000+ U.S. sales tax jurisdictions."),
                            React.createElement("div", null,
                                React.createElement("p", null,
                                    "Included in your subscription: API Access",
                                    hasNonApiConnector &&
                                        React.createElement("span", { "data-ref": 'buy.tier-selector.api-access.connector' }, ` and ${selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.name}`))))),
                    React.createElement(PickerContainer, null,
                        tiers.map((t, i) => (React.createElement(TierTile, { frequency: 'annually', title: { emp: t.quantity.toLocaleString('en-US'), end: ' TRANSACTIONS' }, key: i, onSelectProduct: onSelectTier, selectedProduct: selectedTier, tier: t }))),
                        React.createElement(TierTile, { title: { end: 'Need more?' }, onSelectProduct: onSelectTier, selectedProduct: selectedTier, isSupportTile: true }))),
                React.createElement(Cart, null)),
            React.createElement(TierSelectionPageWrapper, { offsetRight: 50 },
                React.createElement(BaseLinkContainer, null,
                    React.createElement("div", null,
                        React.createElement("p", null,
                            React.createElement(ExternalLink, { "data-ref": 'buy.tier-selector.transaction-definition.link', href: TERMS_LINKS.avatax, alwaysOpenInNewTab: true }, "What is a transaction?")),
                        React.createElement("p", null,
                            React.createElement(ExternalLink, { "data-ref": 'buy.tier-selector.cancellation-terms.link', href: TERMS_LINKS.general, alwaysOpenInNewTab: true }, "See cancellation terms"))))))));
};
export default TierSelector;
